import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ToastController } from 'ionic-angular';
import * as moment from "moment";
import * as firebase from "firebase/app";
import {Params} from "../../params";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";



/**
 * Generated class for the OutputPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-output',
  templateUrl: 'output.html',
})
export class OutputPage {
  day = moment().startOf('day').format();
  data = [];
  company = 'fitfood';
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController ,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController) {
    this.changeDate();
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad OutputPage');
  }

  save(){
    try{
      firebase.firestore().collection('outputs').doc(moment(this.day).format('YYYYMMDD'))
        .set({
          ff: this.data
        },{ merge: true})
        .then(() => {
          let toast = this.toastCtrl.create({
            message: 'Salidas actualizadas exitosamente',
            duration: 3000
          });
          toast.present();
        })
    } catch (e ){
      let toast = this.toastCtrl.create({
        message: 'No se pudo actualizar el stock. ' + e.message,
        duration: 3000
      });
      toast.present();
    }


  }

  changeDate(){
    let loading = this.loadingCtrl.create();
    loading.present();
    setTimeout(()=>{
      const d = [];
      this.data = [];
      console.log(moment(this.day).format('YYYYMMDD'));
      firebase.firestore().collection('outputs').doc(moment(this.day).format('YYYYMMDD'))
        .get().then((iSnap) => {
        if(iSnap.exists){
          this.data = iSnap.data().ff;
          loading.dismiss();
        }else{
          firebase.firestore().collection('orders').doc(moment(this.day).format('YYYYMMDD')).collection('data')
            .where('shipping.delivered','==',true)
            .get().then((snap)=> {
            if(!snap.empty){
              snap.forEach((x)=>{
                d.push(x.data());
              });
              let ings = {};
              for(let c of d) {
                for (let f of c.foods.detail) {
                  if(Object.keys(f.prod).length){
                    f.prod.recipes_uniques.map((r)=>this.sumIngredients(r,ings));
                    f.prod.recipes_principal.map((r)=>this.sumIngredients(r,ings));
                    f.prod.recipes_accompaniment.map((r)=>this.sumIngredients(r,ings));
                    f.prod.recipes_extra.map((r)=>this.sumIngredients(r,ings));
                  }
                }
                this.data = Object.keys(ings)
                  .map((i)=>{
                    let big = false;
                    let total = this.decimals(ings[i].total);
                    let measure = ings[i].measure;
                    if( measure != 'un'){
                      big = (total / 1000 ) > 1;
                      if( big ) {
                        total = this.decimals(ings[i].total / 1000 );
                      } else {
                        measure = this.lmeasure( measure );
                      }
                    }
                    return { big: big, theoric: total, out:total, xtotal: total, xmeasure: measure, ...ings[i]}
                  })
                  .sort((a, b) => {
                    if(a.total > b.total) return -1;
                    if(a.total < b.total) return 1;
                    return 0;
                  });
              }
              console.log(this.data);
            }else{
              let alert = this.alertCtrl.create({
                title: 'No hay información para ese día',
                message: 'Debe esperar que se procese el día solicitado',
                buttons: [
                  {
                    text: 'Comprendo',
                    role: 'cancel'
                  }
                ]
              });
              alert.present();
            }
            loading.dismiss();

            console.log(this.data);
          })
        }
      })
    },1000)





  }

  decimals(num){
    return Number(num.toFixed(3));
  }


  calcTotal(t){
    t.out = this.decimals(Number(t.xtotal) + Number(t.extra) - Number(t.return) + Number(t.decrease));
  }

  sumIngredients(r, ings){
    r.ingredients.map((i)=>{
      if(r.calcportion){
        if(ings[i.id]){
          let total = (Number(i.gross)*r.calcportion)/100;
          if(i.measure == 'un') total = total / i.unitWeight;
          ings[i.id].total = ings[i.id].total + total;
        }else{
          let total = (Number(i.gross)*r.calcportion)/100;
          if(i.measure == 'un') total = total / i.unitWeight;
          ings[i.id] = {
            total :total,
            name : i.name,
            brand : i.brand ? i.brand : '',
            measure : i.measure,
            decrease: 0,
            extra: 0,
            return: 0,
            code: i.code,
            id: i.id
          };
        }
      }else{
        console.error(r);
      }
    })
  }

  lmeasure(m){
    let measure = 'un';
    if(m === 'kg') { measure = 'g' };
    if(m === 'lt') { measure = 'ml' };
    return measure;
  }

  export(){
    const toprint = [
      [
        "Codigo",
        "Nombre",
        "Teorico",
        "Solicitado",
        "Extras",
        "Devolucion",
        "Merma",
        "Total"
      ]
    ];
    this.data.forEach((x) => {
      toprint.push([
        x.code,
        Params.parse_xls(x.name),
        x.theoric + ' ' + x.xmeasure,
        x.xtotal,
        x.extra,
        x.return,
        x.decrease,
        x.out + ' ' +x.xmeasure
      ])
    })
      /* generate worksheet */
      const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(toprint);

      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Inventario');
      /* save to file */
      const wbout: string = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      FileSaver.saveAs(new Blob([wbout]), 'Inventario_'+moment(this.day).format('DD-MM-YYYY')+'.xlsx');
  }
}



// WEBPACK FOOTER //
// ./src/pages/inventory/output/output.ts